<template>
    <div class="fee-item-container">
        <div class="fee-item-layout fee-item-size fee-item-background" @click="onClick">
            <div class="fee-item-background-size" :class="imageClass" v-if="showDefault">
            </div>
            <div class="fee-item-background-size" v-else>
                <img :src="item.src"/>
            </div>
        </div>

        <div class="fee-item-text">
            {{item.name}}
        </div>
    </div>
</template>

<script>
    export default {
        name: "MobileFeeButton",
        props: {
            item: Object
        },
        computed: {
            showDefault() {
                return this.item.src == null
            },
            imageClass() {
                if (this.item.icon) {
                    return `fee-item-${this.item.icon}-img`
                } else {
                    return 'fee-item-default-img'
                }

            }
        },
        methods: {
            onClick() {
                if (this.item.router) {
                    this.$router.push({path: this.item.router})
                } else {
                    this.item.onClick(this.item)
                }
            }
        }

    }
</script>

<style lang="scss" scoped>
    .fee-item-container {
        height: 16vh;
        width: 28vw;
        padding: 0 1vw;
        /*margin-left: 10px;*/
        /*margin-bottom: 10px;*/
    }

    .fee-item-size {
        height: 20vw;
        width: 20vw;
        margin: 0 auto;
    }

    .fee-item-layout {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }


    .fee-item-text {
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .fee-item-background-size {
        height: 7vw;
        width: 7vw;
    }

    .fee-item-default-img {
        background: url("~@/assets/icon/home-page/default-background.png") center no-repeat;
        background-size: 100% 100%;
    }

    .fee-item-background {
        background: url("~@/assets/icon/home-page/home-background.png") center no-repeat;
        background-size: 100% 100%;
    }


    .fee-item-more-img {
        background: url("~@/assets/icon/home-page/more.png") center no-repeat;
        background-size: 100% 100%;
    }

    .fee-item-unpaid-fee-img {
        background: url("~@/assets/icon/home-page/unpaid-fee.png") center no-repeat;
        background-size: 100% 100%;
    }

    .fee-item-pay-record-img {
        background: url("~@/assets/icon/home-page/pay-record.png") center no-repeat;
        background-size: 100% 100%;
    }

    .fee-item-pay-refund-img {
        background: url("~@/assets/icon/home-page/pay-refund.png") center no-repeat;
        background-size: 100% 100%;
    }

    .fee-item-pay-situation-img {
        background: url("~@/assets/icon/home-page/pay-situation.png") center no-repeat;
        background-size: 100% 100%;
    }

</style>
